import { Injectable, Injector, NgZone } from '@angular/core';

export interface PageLayoutSettings {
    /**
     * 0 -> non fa nulla: delega l'eventuale gestione della responsività al componente finale
     * 1 -> se non mobile inserisce il contenuto in una card
     */
    layoutType?: 0|1|2;
    notMobileMaxWidth?: number;
    showBreadcrumbs?: boolean;
    showFabButtons?: boolean;
    bgColor?: string;
    verticallyCentered?: boolean;
    minSupportedWidth?: number; 
    fixedbreadcrumbs?: boolean;
}

@Injectable()
export class PageLayoutDataService {
    layoutType?: 0|1|2;
    notMobileMaxWidth?: number;
    newItemUrl?: string; //serve solo al crudGridPageLayout
    loading?: boolean;
    showBreadcrumbs?: boolean;
    showFabButtons?: boolean;
    bgColor: string;
    verticallyCentered: boolean;
    minSupportedWidth: number; 
    fixedbreadcrumbs: boolean;

    fabButtonSetPrimaryAction;
    fabButtonSetSecondaryActions;
    manageFabButtonSetClick;

    constructor(private _injector: Injector) {
        this.init();
    }

    /**
     * Deve essere chiamato ad ogni cambio di page nel costruttore dei components
     * e non nel ngInit dal momento che modificando potenzialmente l'overflow la 
     * pagina deve essere disegnata tassativamente con l'overflow definitivo 
     * (un cambio di overflow non viene recepito)
     * @param pageLayoutSettings 
     */
    public init(pageLayoutSettings?:PageLayoutSettings){
        pageLayoutSettings = pageLayoutSettings||{};
        this.layoutType = pageLayoutSettings.layoutType || 0;
        this.notMobileMaxWidth = pageLayoutSettings.notMobileMaxWidth || 800;
        this.newItemUrl = null
        this.loading = true
        this.showBreadcrumbs = [null,undefined].includes(pageLayoutSettings.showBreadcrumbs)?true:pageLayoutSettings.showBreadcrumbs
        this.showFabButtons = [null,undefined].includes(pageLayoutSettings.showFabButtons)?true:pageLayoutSettings.showFabButtons
        this.bgColor = pageLayoutSettings.bgColor
        this.verticallyCentered = [null,undefined].includes(pageLayoutSettings.verticallyCentered)?false:pageLayoutSettings.verticallyCentered
        this.minSupportedWidth = pageLayoutSettings.minSupportedWidth||0
        this.fixedbreadcrumbs = [null,undefined].includes(pageLayoutSettings.fixedbreadcrumbs)?false:pageLayoutSettings.fixedbreadcrumbs
    } 
}